@import '../../../../constants/spacing.module.less';

.country-filter-container {
  padding: @space-12;
  min-width: 300px;
}
